
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.696","height":"24.696","viewBox":"0 0 24.696 24.696"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_1","data-name":"Group 1","transform":"translate(-132.527 -132.935)"}},[_c('circle',{attrs:{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"12.348","cy":"12.348","r":"12.348","transform":"translate(132.527 132.935)","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_1","data-name":"Path 1","d":"M151.7,141.053a5.54,5.54,0,0,1-1.362.388c.219-.037.541-.433.67-.594a2.487,2.487,0,0,0,.452-.824c.012-.024.02-.053,0-.071a.076.076,0,0,0-.072.006,6.961,6.961,0,0,1-1.615.618.107.107,0,0,1-.111-.029,1.222,1.222,0,0,0-.142-.145,2.823,2.823,0,0,0-.782-.479,2.718,2.718,0,0,0-1.2-.193,2.856,2.856,0,0,0-1.138.321,2.934,2.934,0,0,0-.918.75,2.826,2.826,0,0,0-.548,1.1,2.961,2.961,0,0,0-.029,1.16c.008.065,0,.074-.056.065a8.625,8.625,0,0,1-5.549-2.825c-.065-.073-.1-.073-.153.006a2.814,2.814,0,0,0,.48,3.325c.109.1.22.206.341.3a2.835,2.835,0,0,1-1.071-.3c-.065-.041-.1-.018-.1.056a1.66,1.66,0,0,0,.018.318,2.844,2.844,0,0,0,1.753,2.268,1.627,1.627,0,0,0,.356.108,3.168,3.168,0,0,1-1.05.033c-.077-.015-.106.024-.077.1A2.957,2.957,0,0,0,142,148.358c.1.017.2.017.3.041-.006.009-.012.009-.018.017a3.487,3.487,0,0,1-1.507.8,5.394,5.394,0,0,1-2.288.293c-.123-.018-.149-.017-.182,0s0,.05.035.082c.156.1.315.194.477.283a7.536,7.536,0,0,0,1.529.612,8.15,8.15,0,0,0,7.911-1.85,8.3,8.3,0,0,0,2.189-6.056c0-.087.1-.135.164-.181a5.363,5.363,0,0,0,1.076-1.119.341.341,0,0,0,.072-.215v-.011C151.754,141.017,151.753,141.028,151.7,141.053Z","fill":"#fd7e14"}})])])
          )
        }
      }
    